{
  "version": 1,
  "asset_id": "71ea5e32-75aa-4f58-a516-ab9711c2a632",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/71ea5e32-75aa-4f58-a516-ab9711c2a632/loc-dallas-1280.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/71ea5e32-75aa-4f58-a516-ab9711c2a632/loc-dallas-1280.webp",
  "original_filename": "loc-dallas-1280.webp",
  "size": 92832,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:26:20Z"
}
